import React from "react";
import { View } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import HelpCenterPopupComponent from "./HelpCenterPopupComponent";
import { disputeCenterData } from "../../Api/help-center-json-data/dispute-center";
import HelpCenterTitleComponent from "./HelpCenterTitleComponent";

const DisputeCenterTabComponent = () => {
  const styles = useStyles();

  return (
    <>
      <HelpCenterTitleComponent title={disputeCenterData.DisputeCentre.Title} />
      <View
        style={{
          backgroundColor: AppColors.appBlueColor_3A5175,
          borderRadius: 10,
          padding: 20,
        }}
      >
        <View style={{ gap: 20 }}>
          <View style={styles.contentContainer}>
            <HelpCenterPopupComponent
              steps={disputeCenterData.DisputeCentre.Steps}
              topData={disputeCenterData.DisputeCentre.GeneralTopData}
              bottomData={disputeCenterData.DisputeCentre.GeneralBottomData}
              tab={"DisputeCenter"}
            />
          </View>
        </View>
      </View>
    </>
  );
};

export default DisputeCenterTabComponent;

const useStyles = CreateResponsiveStyle(
  {
    tabContainer: {
      flexDirection: "row",
      gap: 20,
    },
    tabButton: {
      alignItems: "center",
      paddingVertical: 8,
      flexDirection: "row",
      backgroundColor: AppColors.gray_6E90B4,
      justifyContent: "space-between",
      paddingHorizontal: 10,
      borderRadius: 10,
      width: 154,
      height: 45,
    },

    contentContainer: {
      marginTop: 10,
      paddingHorizontal: 10,
    },
    arrowIcon: {
      width: 10,
      height: 5,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: { tabButton: { height: 29, width: 140 } },
    [DEVICE_SIZES.XS]: { tabButton: { height: 29, width: 140 } },
  }
);
